export const links = {
    tracking: 'http://help.elasticemail.com/en/articles/2288327-how-to-track-opens-and-clicks',
    pruning: 'https://help.elasticemail.com/en/articles/4867718-contact-pruning',
    contactUpload: 'https://help.elasticemail.com/en/articles/4966686-how-to-upload-your-contacts',
    contactsCountingOnUnlimitedPlans: 'https://help.elasticemail.com/en/articles/2553114-how-are-contacts-counted-on-unlimited-plans',
    unsubscribeSettings: 'https://help.elasticemail.com/en/articles/4808492-unsubscribe-settings',
    contactListsAndSegments: 'https://help.elasticemail.com/en/articles/4984897-contact-lists-and-segments',
    creatingCustomFields: 'https://help.elasticemail.com/en/articles/5016927-custom-contact-fields',
    trackingOpensAndClicks: 'https://help.elasticemail.com/en/articles/4867123-tracking-opens-and-clicks',
    apiUserFile: 'https://api.elasticemail.com/userfile/',
    contactHistory: 'https://help.elasticemail.com/en/articles/5070527-contact-history',
    usagePolicies: 'https://elasticemail.com/resources/usage-policies',
    blacklistedDomain: 'https://mxtoolbox.com/blacklists.aspx',
    contactPage: 'https://elasticemail.com/contact',
    termsOfUse: 'https://elasticemail.com/wp-json/wp/v2/posts/399',
    reduceEmailBounceRate: 'https://help.elasticemail.com/en/articles/2419232-how-to-reduce-email-bounce-rate',
    complaintsThreshold: 'https://help.elasticemail.com/en/articles/2300649-what-is-the-complaints-threshold',
    manageReputationAndDelivery: 'https://help.elasticemail.com/en/articles/2361436-how-to-manage-reputation-and-delivery',
    howToCreateIpPool: 'https://help.elasticemail.com/en/articles/4804547-private-ip-settings',
    dedicatedSupport: 'https://elasticemail.com/dedicated-support',
    whatisemaildeliverystatus: 'https://help.elasticemail.com/en/articles/2300646-what-is-email-delivery-status',
    helpBounceErrorCategoriesAndFilters:
        'https://help.elasticemail.com/en/articles/2300650-what-are-the-bounce-error-categories-and-filters',
    inboundNotification: 'https://help.elasticemail.com/en/articles/4804685-notification-settings',
    welcomeDialogApiUrl: '#',
    welcomeDialogMarketingUrl: '#',
    bounceErrorsCategories: 'https://help.elasticemail.com/en/articles/2300650-what-are-the-bounce-error-categories-and-filters',
    customBrandingPage: 'https://elasticemail.com/custom-branding',
    tlsArticle: 'https://elasticemail.com/blog/why-were-retiring-older-versions-of-tls',
    smtpHelp: 'http://help.elasticemail.com/en/articles/4803409-smtp-settings',
    apiHelp: 'http://help.elasticemail.com/en/articles/4799160-api-settings',
};
